import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';

export const routes: Routes = [
  { path: '', redirectTo: '/landing', pathMatch: 'full' },
  {
    path: 'landing',
    title: 'Capsulas',
    loadComponent: () =>
      import('./pages/landing-page-v2/landing-page-v2.component').then(
        (m) => m.LandingPageV2Component
      ),
  },
  {
    path: 'login-nuevo',
    title: 'Iniciar Sesión - InfoCaps',
    loadComponent: () =>
      import('./pages/landing-page-v2/landing-page-v2.component').then(
        (m) => m.LandingPageV2Component
      ),
  },
  {
    path: 'home',
    title: 'Home Capsulas',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./pages/home/home.routes').then((m) => m.HOME_ROUTES),
  },
  {
    path: 'contenido/:tinyUrlCode',
    title: 'Visualizador de Cápsula',
    loadComponent: () =>
      import('./features/capsule-viewer/capsule-viewer.component').then(
        (m) => m.CapsuleViewerComponent
      ),
  },
  {
    path: 'evaluacion/:evaluacionId/:funcionarioId',
    title: 'Visualizador de Cápsula',
    loadComponent: () =>
      import('./features/evaluacion-viewer/evaluacion-viewer.component').then(
        (m) => m.EvaluacionViewerComponent
      ),
  },
  { path: '**', redirectTo: '/landing' },
];
